import styled from "styled-components";

export const Container = styled.div`
    width: 80%;
    margin: 0 auto;
    text-align: center;
`;


export const Headline = styled.h2`
    font-size: 2.5rem;
    margin: 1rem 0;
    @media (max-width: 1050px) {
        font-size: 2rem;
    }
`;

